import axios from 'axios';
import ClipboardJS from 'clipboard';
import moment from 'moment';
import Swal from 'sweetalert2';
import { apkVersionToString } from './helpers/apkHelper';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { getMtaApBasicData, hydrateApBasicData } from './helpers/basicHelper';
import { Toast, addDNoneClass, btnLoading, byId, convertToTwoDecimalInt, unixTimeStampInSeconds } from './helpers/utility';
import webApkInterface from './helpers/webApkInterfaceHelper';






authHelper.validate();
hydrateApBasicData();

window.webApkInterface = webApkInterface;

const activePlan = getMtaApBasicData().activePlan;


const logo_display = byId('logo_display');
const upload_btn = byId('upload_btn');
const logo_link = byId('logo_link');
const logo_file = byId('logo_file');
const aab_check = byId('aab_check');
const playstore_check = byId('playstore_check');
const order_now_btn = byId('order_now_btn');
const aab_li = byId('aab_li');
const playStoreUpload_li = byId('playStoreUpload_li');
const apkPriceSpan = byId('apkPriceSpan');
const aabPriceSpan = byId('aabPriceSpan');
const playStoreUploadPriceSpan = byId('playStoreUploadPriceSpan');
const total_span = byId('total_span');
const webApkDetailsDivElement = byId('webApkDetailsDivElement');
const webApkDefaultLinkInput = byId('webApkDefaultLinkInput');
const webAabLinkInput = byId('webAabLinkInput');
const webApkOrderDivElement = byId('webApkOrderDivElement');
const appNameInput = byId('appNameInput');
const webApkVersionInput = byId('webApkVersionInput');


const webApkListTableBodyElement = byId('webApkListTableBodyElement');





var webApkDefaultLinkInput_clipboard = new ClipboardJS('#webApkDefaultLinkInput_clipboard');
var webAabLinkInput_clipboard = new ClipboardJS('#webAabLinkInput_clipboard');

webApkDefaultLinkInput_clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Apk link Copied 🥰', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});
webAabLinkInput_clipboard.on('success', function (e) {


    e.clearSelection();
    Swal.fire({
        icon: 'success',
        title: 'Aab Link Copied 🥰', toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
});



function order_new_apk_init_fun(status) {

    if (status === true) {
        addDNoneClass(webApkDetailsDivElement, true);
        addDNoneClass(webApkOrderDivElement, false);
    }
    if (status === false) {
        addDNoneClass(webApkDetailsDivElement, false);
        addDNoneClass(webApkOrderDivElement, true);
    }

}

window.order_new_apk_init_fun = order_new_apk_init_fun;



function logo_remove_fun() {
    logo_link.value = '';
    logo_file.value = '';

    logo_display.src = logo_link.value;
}
window.logo_remove_fun = logo_remove_fun;

const apkOrderPriceHiddenTextSpan = byId('apkOrderPriceHiddenTextSpan');
const aabOrderPriceHiddenTextSpan = byId('aabOrderPriceHiddenTextSpan');
const playstoreUploadPriceHiddenTextSpan = byId('playstoreUploadPriceHiddenTextSpan');

let isAbbSelected = false;
let isPlaystoreUploadSelected = false;

const calculateAllFun = () => {
    const apkPrice = convertToTwoDecimalInt(apkOrderPriceHiddenTextSpan.innerHTML);
    const aabPrice = convertToTwoDecimalInt(aabOrderPriceHiddenTextSpan.innerHTML);
    const playstoreUploadPrice = convertToTwoDecimalInt(playstoreUploadPriceHiddenTextSpan.innerHTML);

    // displaying price 
    apkPriceSpan.innerText = apkPrice;
    aabPriceSpan.innerText = aabPrice;
    playStoreUploadPriceSpan.innerText = playstoreUploadPrice;

    // calculating price 

    let totalPrice = apkPrice;
    if (isAbbSelected) {
        totalPrice = totalPrice + aabPrice;
    }
    if (isPlaystoreUploadSelected) {
        totalPrice = totalPrice + playstoreUploadPrice;
    }


    total_span.innerHTML = totalPrice;
};
calculateAllFun();

function aab_check_change_fun() {

    if (activePlan !== 'premium' && activePlan !== 'starter') {

        Toast.fire({
            icon: 'error',
            title: 'Starter Plan Required'
        });

        aab_check.checked = false;
    } else {
        // console.log( aab_check.checked);
        isAbbSelected = aab_check.checked;
        if (aab_check.checked === true) {
            addDNoneClass(aab_li, false);

        }
        if (aab_check.checked === false) {
            addDNoneClass(aab_li, true);

            playstore_check.checked = false;
            // eslint-disable-next-line no-use-before-define
            playStoreUpload_check_change_fun();
        }
        calculateAllFun();
    }


}
window.aab_check_change_fun = aab_check_change_fun;


function playStoreUpload_check_change_fun() {

    // console.log( aab_check.checked);
    isPlaystoreUploadSelected = playstore_check.checked;
    if (playstore_check.checked === true) {
        addDNoneClass(playStoreUpload_li, false);

        aab_check.checked = true;
        aab_check_change_fun();
    }
    if (playstore_check.checked === false) {
        addDNoneClass(playStoreUpload_li, true);

    }
    calculateAllFun();
}
window.playStoreUpload_check_change_fun = playStoreUpload_check_change_fun;








const placeWebApkOrderFun = async () => {
    try {

        const logoLink = logo_link.value;


        // validation 
        if (logoLink === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Upload Web Apk Logo', toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
            return false;
        }


        let orderType = 'apk';
        if (isAbbSelected) {
            orderType = 'apkAndAab';
        }
        if (isPlaystoreUploadSelected) {
            orderType = 'apkAndAabAndPlaystoreUpload';
        }
        const data = { logoLink, orderType };

        console.log(data);

        btnLoading(order_now_btn, 'Loading...', true);
        const response = await callTheApServerPost(`/basic/placeWebApkOrder`, { data: data });
        axiosResponseHandler(response);
        const res = response.data;

        btnLoading(order_now_btn, 'Loading...', false);




        if (res.status === 'success') {
            console.log(res);

            Swal.fire({
                icon: 'success',
                title: 'New Web Apk Ordered 😍',
                html: `Now wait ! <br> it may take approx 24 hours to get Your Web Apk Ready <br> after Complete Download link will automatically Updated here `,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'ok ',

            });

            setTimeout(() => { location.reload(); }, 5000);
        }
        if (res.status === 'googleServiceJsonNotFound') {
            Swal.fire({
                icon: 'warning',
                title: 'google-services.json not found 😢',
                text: 'google-services.json is Required to Order Web Apk.',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Configure google-services.json',
                denyButtonText: `Cancel`,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    location.href = './webApk_configs.html';
                } else if (result.isDenied) {
                    Swal.fire('Web Apk Order Cancelled', '', 'info');
                }
            });
        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

window.placeWebApkOrderFun = placeWebApkOrderFun;











const getWebApkListFun = async () => {
    try {


        const response = await callTheApServerGet(`/basic/getWebApkList`);
        axiosResponseHandler(response);
        const res = response.data;

        appNameInput.value = getMtaApBasicData().appName;




        if (res.status === 'success') {
            console.log(res);
            if (res?.apkLogoLink !== '') {
                logo_display.src = `${res?.apkLogoLink}?v=${unixTimeStampInSeconds()}`;
            }
            logo_link.value = res?.apkLogoLink;

            if (res?.mtaConfig) {
                apkOrderPriceHiddenTextSpan.innerText = res?.mtaConfig.webApkOrderPrice;
                aabOrderPriceHiddenTextSpan.innerText = res?.mtaConfig.webAabOrderPrice;
                playstoreUploadPriceHiddenTextSpan.innerText = res?.mtaConfig.playstoreUploadOrderPrice;
            }

            calculateAllFun();
            if (res.webApkList.length > 0) {



                const { aabLink, version, status, apkLink } = res.webApkList[0];
                webApkVersionInput.value = apkVersionToString(version);
                webApkDefaultLinkInput.value = apkLink;
                webAabLinkInput.value = aabLink;

                if (status === 'pending') {
                    webApkDefaultLinkInput.value = `Order is in Progress`;
                    webAabLinkInput.value = `Order is in Progress`;
                }





                addDNoneClass(webApkDetailsDivElement, false);
                webApkListTableBodyElement.innerHTML = '';
                let i = 0;
                while (res.webApkList.length > i) {

                    // eslint-disable-next-line no-unused-vars
                    const { logoLink, version, createdAt, status, apkLink } = res.webApkList[i];
                    let localStatus;
                    if (status === 'pending') {
                        localStatus = 'Processing...';
                    } else {
                        localStatus = status;
                    }

                    let apkDownloadBtn = '';
                    if (apkLink !== '') {

                        apkDownloadBtn = `<a onclick="webApkInterface.openInBrowser('${apkLink}')" class="btn btn-primary ">Download</a>`;
                    }

                    const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(createdAt * 1000).format('LT');
                    webApkListTableBodyElement.innerHTML += `<tr>
                                <th scope="row">${apkVersionToString(version)}</th>
                    
                                <td>${localStatus}</td>
                                <td>${date} <br> ${time}</td>
                                <td>${apkDownloadBtn}</td>
                                 
                            </tr>`;

                    i++;
                }
            } else {





                addDNoneClass(webApkOrderDivElement, false);
                webApkListTableBodyElement.innerHTML = `
                <tr >
                <th colspan='5' class='text-center'>Web Apk Not found 😢 <br> Order New One 🥰 </th>

            </tr>`;


            }


        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};

getWebApkListFun();




logo_file.addEventListener('change', function () {
    btnLoading(upload_btn, '', true);
    btnLoading(order_now_btn, 'Uploading', true);
    logo_display.src = 'assets/gif/uploading.gif';

    // const [file] = logo_file.files;

    const bodyFormData = new FormData();
    bodyFormData.set('key', 'b5421852000117a841c8016b15fa67ea');
    bodyFormData.append('image', logo_file.files[0]);
    axios.post('https://api.imgbb.com/1/upload', bodyFormData)
        .then(function (response) {
            console.log(response.data.data.url);

            if (response.data.data.url) {
                logo_link.value = response.data.data.url;

            } else {
                logo_link.value = '';

            }
            logo_display.src = logo_link.value;
            btnLoading(upload_btn, '', false);
            btnLoading(order_now_btn, 'Uploading', false);





        })
        .catch(function (error) {
            console.log(error);
        });

});

const getFreeWebApkVideoLinksDivElement = byId('getFreeWebApkVideoLinksDivElement');

const getFreeWebApkVideoLinksFun = () => {
    addDNoneClass(getFreeWebApkVideoLinksDivElement, false);

    setTimeout(() => {
        addDNoneClass(getFreeWebApkVideoLinksDivElement, true
        );
    }, 5000);
};

window.getFreeWebApkVideoLinksFun = getFreeWebApkVideoLinksFun;


